export const APP_NAME = 'Turnkey Designers'
export const TOKEN_NAME = 'ORBIT-TOKEN'

export const ACCOUNT_TYPES = {
  OWNER: 'owner',
  ADMINISTRATOR: 'administrator',
  MEMBER: 'member'
}

export const PROJECT_ACCOUNT_TYPES = {
  OWNER: 'owner',
  CONTRIBUTOR: 'contributor',
  ADMINISTRATOR: 'administrator',
  NON_CONTRIBUTOR: 'non-contributor'
}

export const NOTIFICATION_TYPES = {
  INVITATION: 'invitation',
  TASK: 'task assign and others'
}

export const projectAccountTypes = Object.keys(PROJECT_ACCOUNT_TYPES).map((key) => ({
  text: PROJECT_ACCOUNT_TYPES[key],
  value: key
}))

export const orgAccountTypes = Object.keys(ACCOUNT_TYPES).map((key) => ({
  text: ACCOUNT_TYPES[key],
  value: key
}))